import React from 'react'
import { useHistory } from 'react-router-dom'
import { Col, Row } from 'react-bootstrap'
import { REQUEST_CHEQUE_MENUS } from '../../Layout/menu-names'
import LayoutWithAccountCard from '../../Layout/layout-account-card'
import { useTranslation } from 'react-i18next';
import { getMenuListSelector } from '../../../store/selectors/app.selector'
import { useSelector } from 'react-redux'

export default function Cheque() {
  const history = useHistory()
  const {t}=useTranslation()
  const menuConfig = useSelector(getMenuListSelector)['CHEQUE'] || {}

  return (
    <LayoutWithAccountCard breadCumKey={'REQUEST_CHEQUE'}>
      <Row>
        {Object.keys(menuConfig).length>0 && REQUEST_CHEQUE_MENUS.map((option, index) => (
          <>
          {menuConfig[option.key] && (
          <Col
            xs={'auto'}
            sm={'auto'}
            md={'auto'}
            key={index}
            className='account-menu-card'
            onClick={() => history.push(option.link)}>
            <img width={52} height={40} src={option.icon} />
            <h2>{t(option.title)}</h2>
            <span>{t(option.desc)}</span>
          </Col>
          )}
          </>
        ))}
      </Row>
    </LayoutWithAccountCard>
  )
}
